import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { addErrorMessage, addMessage as addMessageAction } from 'my-actions/MessageActions';

export default function useAddMessage() {
  const dispatch = useDispatch();
  const addMessage = useCallback(
    (message, { isError } = {}) => dispatch((isError ? addErrorMessage : addMessageAction)(message)),
    [dispatch],
  );

  return addMessage;
}
